import * as actionTypes from '../actions/actionTypes';

const initialState = {
  permissionsMap: {},
  fetching: true,
  error: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_USER_PERMISSIONS_SUCCESS:
      return {
        ...state,
        permissionsMap: action.permissionsMap,
        fetching: false
      };
    case actionTypes.FETCH_USER_PERMISSIONS_FAIL:
      return {
        ...state,
        fetching: false,
        error: true
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./app/javascript/app/store/reducers/entitlements.js